import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Bubble, Copy, Icon} from 'kpc';

var _$tmp0 = {
    'placement': 'end',
    'content': '介绍一下你自己',
    'shape': 'corner'
};
var _$tmp1 = {
    'placement': 'middle',
    'variant': 'plain',
    'content': '系统消息：文档已自动保存，3 秒后继续生成。'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Bubble, _$tmp0),
        _$cc(Bubble, {
            'avatar': 'https://dummyimage.com/64x64/1677ff/ffffff&text=A',
            'roleName': 'AI 助手',
            'content': this.get('content'),
            'variant': 'plain',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['bottom'] = function($super) {
                            return (
                                (this.get('showBottom')) ?
                                    _$ce(2, 'div', '\n                这是 bottom 插槽，可放置一些固定信息\n            ', 16, 'bubble-demo-bottom') :
                                    undefined
                            );
                        }),
                        (__$blocks['bottom'] = function($super, data) {
                            var block = $blocks['bottom'];
                            var callBlock = function() {
                                return _$blocks['bottom'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['footer'] = function($super) {
                            return (
                                _$ce(2, 'div', [
                                    _$cc(Icon, {
                                        'className': 'k-icon-refresh',
                                        'title': '重新生成',
                                        'hoverable': true,
                                        'ev-click': this.retry
                                    }),
                                    _$ce(2, 'div', (
                                        _$cc(Copy, {
                                            'text': this.get('content'),
                                            'title': '复制气泡内容'
                                        })
                                    ), 2)
                                ], 4, 'bubble-demo-footer-bar')
                            );
                        }),
                        (__$blocks['footer'] = function($super, data) {
                            var block = $blocks['footer'];
                            var callBlock = function() {
                                return _$blocks['footer'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['extra'] = function($super) {
                            return '12 tokens · 0.4s';
                        }),
                        (__$blocks['extra'] = function($super, data) {
                            var block = $blocks['extra'];
                            var callBlock = function() {
                                return _$blocks['extra'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Bubble, _$tmp1)
    ], 4, 'bubble-demo-basic');
};